import React from 'react';
import { BrowserRouter, Routes, Route, HashRouter } from 'react-router';
import './App.css';
// import './App1.css';
import Company from './components/Company/Company';
import './utils/uikit';
import Project from './components/Project/Project';
import NotFound from './components/NotFound/NotFound';
import { ThemeProvider } from './context/ThemeContext';
import ThemeToggle from './components/ThemeToggle/ThemeToggle';

function App() {
  return (
    <ThemeProvider>
      <HashRouter>
        <div className="App">
          <div id="background"></div>
          <ThemeToggle />
          <div className="mainContainerWrapper">
            <Routes>
              <Route path="/" element={<Company />} />
              <Route path="/company/:companyId" element={<Company />} />
              <Route path="/project/:projectId" element={<Project />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App; 